import { render, staticRenderFns } from "./BoxVoice.vue?vue&type=template&id=73db3ff0&scoped=true&"
import script from "./BoxVoice.vue?vue&type=script&lang=js&"
export * from "./BoxVoice.vue?vue&type=script&lang=js&"
import style0 from "./BoxVoice.vue?vue&type=style&index=0&id=73db3ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73db3ff0",
  null
  
)

export default component.exports